import {Component} from '@angular/core';
import Quill from 'quill';
import {AbstractQuillToolbarButtonComponent} from '../abstract-quill-toolbar-button';

/**
 * Class for the AbstractQuillToolbarFormatButtonComponent
 * @class
 * @abstract
 * @extends AbstractQuillToolbarButtonComponent
 */
@Component({
  selector: 'advtech-abstract-quill-toolbar-format-button',
  templateUrl: './abstract-quill-toolbar-format-button.component.html',
})
export abstract class AbstractQuillToolbarFormatButtonComponent extends AbstractQuillToolbarButtonComponent {
  classes: { 'ql-active' } = {"ql-active": false};

  /** @inheritdoc */
  init(quill: Quill): void {
    super.init(quill);

    this.quill.on('selection-change', (range, oldRange, source) => this.hSelectionChange(range, oldRange, source));
    this.quill.root.on('keyup', (e) => this.hKeyUp(e));
  }

  /**
   * Handles the selection change in the editor
   * @param {any} range
   * @param {any} oldRange
   * @param {any} source
   * @returns {void}
   */
  abstract hSelectionChange(range?, oldRange?, source?): void;

  /**
   * Handles the keyup from the quill editor
   * @param {Event} e
   * @return {void}
   */
  abstract hKeyUp(e): void;
}


// WEBPACK FOOTER //
// ./src/app/content/shared/components/inputs/body/quill-toolbar/buttons/abstract-quill-toolbar-format-button/abstract-quill-toolbar-format-button.component.ts